import { Flex, FlexProps, Spinner } from "@chakra-ui/react";

export type Props = FlexProps & {
  isLoaded?: boolean;
  children?: React.ReactNode;
  withSpinner?: boolean;
};

const SkeletonBox: React.FC<Props> = ({
  isLoaded,
  withSpinner,
  children,
  ...props
}) => {
  if (isLoaded) {
    return children;
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      w="100%"
      bg="#edf2f7"
      {...props}
    >
      {withSpinner && (
        <Spinner size="sm" color="rgba(0, 0, 0, .5)" animationDuration="1s" />
      )}
    </Flex>
  );
};

export default SkeletonBox;
